import { baseUtils } from '../../utils/baseUtils';
import VersionManagerCore from '../versionManager.js';
import { pgVersionManager } from '../proGalleryVersionManager';
export var FullscreenVersionManager = /*#__PURE__*/function () {
  function FullscreenVersionManager(proGallertVersionManager) {
    this.pgVersionManager = proGallertVersionManager || pgVersionManager;
  }

  var _proto = FullscreenVersionManager.prototype;

  _proto.getVersionFullscreenVersion = function getVersionFullscreenVersion() {
    var version = this.pgVersionManager.getVersion('fullscreen');

    if (version === VersionManagerCore.Versions.min) {
      return baseUtils.isDemoMode() || baseUtils.isStoreGallery() ? 'V2' : version;
    }

    return version;
  };

  _proto.useFullScreenWideSidebar = function useFullScreenWideSidebar() {
    return this.getVersionFullscreenVersion() !== VersionManagerCore.Versions.min;
  };

  _proto.useFullScreenMobilePadding = function useFullScreenMobilePadding() {
    return this.getVersionFullscreenVersion() !== VersionManagerCore.Versions.min;
  };

  _proto.useFullScreenMoreinfoButtonAlways = function useFullScreenMoreinfoButtonAlways() {
    return this.getVersionFullscreenVersion() === VersionManagerCore.Versions.min;
  };

  _proto.useFullscreenNewDesktopNavbar = function useFullscreenNewDesktopNavbar() {
    return this.getVersionFullscreenVersion() !== VersionManagerCore.Versions.min;
  };

  _proto.useFullscreenNewSidebar = function useFullscreenNewSidebar() {
    return this.getVersionFullscreenVersion() !== VersionManagerCore.Versions.min;
  };

  _proto.useFullscreenNewSlider = function useFullscreenNewSlider() {
    return this.getVersionFullscreenVersion() !== VersionManagerCore.Versions.min;
  };

  _proto.useFullscreenNewMobileLayout = function useFullscreenNewMobileLayout() {
    return this.getVersionFullscreenVersion() !== VersionManagerCore.Versions.min;
  };

  _proto.useFullscreenSettingsNewVersion = function useFullscreenSettingsNewVersion() {
    return this.getVersionFullscreenVersion() !== VersionManagerCore.Versions.min;
  };

  _proto.update = function update(dateCreated) {
    return this.pgVersionManager.update(dateCreated);
  };

  return FullscreenVersionManager;
}();
export default new FullscreenVersionManager();